import { useTranslation } from 'react-i18next';
import { RootStyled } from './not-found.styled';
import { Stack, Typography } from '@mui/material';
import { JButton } from '@atoms/JButton';
import { useNavigate } from 'react-router-dom';
import Paths from '@/routes/paths';

const NotFound = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <RootStyled>
      <Stack alignItems="center">
        <Typography variant="h2"> 404</Typography>
        <Typography>{t('PAGE_NOT_FOUND')}</Typography>
        <Stack direction="row" mt={1} gap={1}>
          <JButton onClick={() => navigate(-1)} variant="text">
            {t('BACK_PREV')}
          </JButton>

          <JButton
            onClick={() => navigate(Paths.CvVideos)}
            variant="contained"
            color="primary"
          >
            {t('BACK_HOME')}
          </JButton>
        </Stack>
      </Stack>
    </RootStyled>
  );
};

export default NotFound;
